import { render } from "./UserOrderDetailsComponent.vue?vue&type=template&id=bf089564&scoped=true"
import script from "./UserOrderDetailsComponent.vue?vue&type=script&lang=js"
export * from "./UserOrderDetailsComponent.vue?vue&type=script&lang=js"

import "./UserOrderDetailsComponent.vue?vue&type=style&index=0&id=bf089564&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf089564"]])

export default __exports__